export default () => ({
  id: null,
  quantity: null,
});
